import React, { Component } from "react";
import { message, PageHeader, Col, Row, Spin, Select, Tabs, Alert, Divider, Tag, Upload } from "antd";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import {
  Form, FormItem, ButtonItem, InputItem, InputNumberItem,
  SelectItem, ErrorItem, SwitchItem, DatePickerItem,
  SelectDepartamentosItem, SelectPuestosItem, SelectTurnosItem, SelectEmpleadosItem,
  fechaDiaParaPayload
} from "../../../../Components/Items";
import { PlusOutlined, MinusCircleOutlined, EyeOutlined, LockOutlined, ScanOutlined, UpOutlined, DownOutlined, UploadOutlined, DeleteOutlined, UserOutlined } from "@ant-design/icons";
import ModalPrevisualizarArchivos from "../../../../Components/ModalPrevisualizarArchivos";
import SelectPerimetrosChecadaItem from "../../../../Components/SelectPerimetrosChecadaItem";
import FotoRostroEmpleado from "../../../../Components/FotoRostroEmpleado";
import {
  regimenIdEsAsimilado, aplicarCambioDeRegimen, percepcionIncluida, alternarPercepcion,
} from "../conceptosAsimilados";
import { calcularSbcParteFija, MOTIVO_SBC_TEXTO } from "../sbc";
import CalculadoraCurp from "../CalculadoraCurp";
import CalculadoraRfc from "../CalculadoraRfc";
import "../capturaEmpleado.css";

const { Option } = Select;
const { TabPane } = Tabs;
const LBL = { span: 8 };
const WRP = { span: 16 };

// SBC automático, igual que en Editar Empleado. Cambiar cualquiera de los primeros recalcula la
// parte fija (salario × factor de la tabla de prestaciones); cambiar la variable o la fija a mano
// sólo recalcula el topado.
const CAMPOS_SBC_PARTE_FIJA = ["salarioDiario", "tipoPrestacionId", "fechaAlta", "fechaReingreso", "baseDeCotizacion"];
const CAMPOS_SBC_TOPADO = ["sbcParteFija", "sbcParteVariable"];
const redondear2 = (n) => Math.round(n * 100) / 100;

const MAX_ARCHIVOS_DOCUMENTOS = 3;
const TIPOS_ARCHIVO_DOCUMENTOS = ["application/pdf", "image/jpeg", "image/png", "image/webp"];

// El código del empleado es numérico en el modelo: cualquier letra que se escriba aquí
// revienta el cast de Mongoose al guardar y al checar duplicados. Se filtra el tecleo
// para que la letra ni siquiera llegue a aparecer en el campo.
const soloDigitos = (e) => String(e?.target?.value ?? "").replace(/[^0-9]/g, "");

function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

const normFile = (e) => (Array.isArray(e) ? e : e && e.fileList);

const CredencialCard = ({ icon, titulo, activo, color, detalle }) => (
  <div style={{
    border: `1px solid ${activo ? color + "55" : "#e8e8e8"}`,
    borderRadius: 8, padding: "20px 16px",
    background: activo ? `${color}08` : "#fafafa",
    display: "flex", flexDirection: "column", alignItems: "center", gap: 10,
    minHeight: 150, transition: "all 0.2s",
  }}>
    <div style={{ color: activo ? color : "#bbb", fontSize: 36, lineHeight: 1 }}>{icon}</div>
    <span style={{ fontWeight: 600, fontSize: 14, color: "#333" }}>{titulo}</span>
    <Tag color={activo ? "success" : "default"} style={{ margin: 0 }}>{activo ? "Registrado" : "Sin datos"}</Tag>
    {detalle && <span style={{ fontSize: 11, color: "#888", textAlign: "center" }}>{detalle}</span>}
  </div>
);

class AgregarEmpleado extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    siguienteCodigo: null,
    objetoFigurasTranporte: null, objetoPaises: null, objetoPaisesResidencia: null,
    objetoEstados: null, objetoTiposContrato: null, objetoTiposPrestacion: null,
    objetoFormasDePago: null, objetoTiposPeriodo: null, objetoTiposJornada: null,
    objetoRegimenFiscal: null, objetoTipoRegimen: null, objetoBancos: null, objetoRegistrosPatronales: null,
    objetoEstadosNacimiento: null,
    todasMunicipios: [], todasColonias: [], objetoMunicipios: null, objetoColonias: null,
    // Datos crudos para cálculo F10
    todasTiposPrestacion: [],
    todasConceptos: [],
    objetoConceptos: null,
    filePreviewVisible: false, currentPreviewFile: null,
    // Régimen de asimilados a salarios. El catálogo crudo hace falta para leer el
    // c_TipoRegimen del _id seleccionado (el <Option> sólo lo lleva en la etiqueta), y
    // `conceptosGlobalesIds` se guarda para poder devolver el juego normal si el usuario
    // se arrepiente y cambia el régimen de vuelta.
    todosTiposRegimen: [],
    conceptosGlobalesIds: [],
    asimilados: null,
    esAsimilado: false,
    tipoRegimenIdPrevio: null,
    // SBC automático: la UMA vigente para el tope de 25 UMAs, y el texto que explica el último
    // cálculo (o por qué no se pudo).
    umaVigente: null,
    sbcAuto: null,
  };

  atras() { this.props.history.goBack(); }
  componentDidMount() {
    this.consultarTodo();
    window.addEventListener("keydown", this.onKeyDown);
  }
  componentWillUnmount() {
    window.removeEventListener("keydown", this.onKeyDown);
    clearTimeout(this.timerSbc);
  }

  onKeyDown = (e) => {
    if (e.key === "F10") { e.preventDefault(); this.calcularSBC(); }
  };

  async consultarTodo() {
    this.setState({ loading: true });
    await axios.post("empleados/datosParaEmpleado", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.status === 404) return;
        const s = {
          objetoFigurasTranporte: res.data.figurasTranporte?.map((v) => <Option value={v._id} key={v._id}>{v.Clave + " - " + v.Descripcion}</Option>),
          objetoPaises: res.data.paises?.map((v) => <Option value={v._id} key={v._id}>{v.nombre + " - " + v.abreviatura}</Option>),
          objetoPaisesResidencia: res.data.paisesResidencia?.map((v) => <Option value={v._id} key={v._id}>{v.nombre + " - " + v.abreviatura}</Option>),
          objetoEstados: res.data.estados?.map((v) => <Option value={v._id} key={v._id}>{v.nombre + " - " + v.abreviatura}</Option>),
          objetoEstadosNacimiento: res.data.estados?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
        };
        if (this.props.nomina) {
          Object.assign(s, {
            objetoTiposContrato: res.data.tiposContrato?.map((v) => <Option value={v._id} key={v._id}>{v.c_TipoContrato + " - " + v.Descripcion}</Option>),
            objetoTiposPrestacion: res.data.tiposPrestacion?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
            todasTiposPrestacion: res.data.tiposPrestacion || [],
            todasConceptos: res.data.conceptosNomina || [],
            objetoFormasDePago: res.data.formasDePago?.map((v) => <Option value={v._id} key={v._id}>{v.c_FormaPago + ' - ' + v.descripcion}</Option>),
            objetoTiposPeriodo: res.data.tiposPeriodo?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
            objetoTiposJornada: res.data.tiposJornada?.map((v) => <Option value={v._id} key={v._id}>{v.c_TipoJornada + " - " + v.Descripcion}</Option>),
            objetoRegimenFiscal: res.data.regimenFiscal?.map((v) => <Option value={v._id} key={v._id}>{v.c_RegimenFiscal + " - " + v.descripcion}</Option>),
            objetoTipoRegimen: res.data.tiposDeRegimenes?.map((v) => <Option value={v._id} key={v._id}>{v.c_TipoRegimen + " - " + v.descripcion}</Option>),
            objetoBancos: res.data.bancos?.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>),
            objetoRegistrosPatronales: res.data.registrosPatronales?.map((v) => <Option value={v._id} key={v._id}>{v.registroPatronalIMSS}</Option>),
            umaVigente: res.data.umaVigente || null,
          });

          // El alta nace con la prestación "De Ley" (o la única que haya) para que el SBC se
          // calcule solo desde que se teclea el salario. Si no hay ninguna así, se queda vacía.
          const prestaciones = res.data.tiposPrestacion || [];
          const prestacionDeLey = prestaciones.length === 1
            ? prestaciones[0]
            : prestaciones.find((p) => /de\s*ley/i.test(p.nombre || ""));
          if (prestacionDeLey) {
            this.formRef.current.setFieldsValue({ tipoPrestacionId: prestacionDeLey._id });
          }
          const conceptosGlobales = (res.data.conceptosNomina || [])
            .filter(c => c.estado === 1 && c.automaticoGlobal === true)
            .map(c => c._id);

          // Se guardan además de escribirse: son el juego al que hay que volver si el
          // empleado se marca como asimilado y después se le quita.
          Object.assign(s, {
            todosTiposRegimen: res.data.tiposDeRegimenes || [],
            conceptosGlobalesIds: conceptosGlobales,
            asimilados: res.data.asimilados || null,
          });

          if (conceptosGlobales.length > 0) {
            this.formRef.current.setFieldsValue({ conceptosIds: conceptosGlobales });
          }
        }
        if (res.data.siguienteCodigo !== undefined) {
          this.setState({ siguienteCodigo: res.data.siguienteCodigo });
          this.formRef.current.setFieldsValue({ codigo: res.data.siguienteCodigo });
        }
        this.setState(s);
      });
    this.setState({ loading: false });
  }

  // Cambio de Tipo de Régimen. El reemplazo de conceptos se propone aquí, con su diff, y
  // se escribe en el formulario para que quede visible y editable antes de guardar.
  onCambiarTipoRegimen = async (value) => {
    const { todosTiposRegimen, esAsimilado, asimilados, todasConceptos, conceptosGlobalesIds } = this.state;
    const seraAsimilado = regimenIdEsAsimilado(value, todosTiposRegimen);

    // Sólo importa cruzar la frontera: cambiar entre dos claves de asimilados (09 → 11)
    // no cambia qué conceptos le tocan.
    if (seraAsimilado === esAsimilado) {
      this.setState({ tipoRegimenIdPrevio: value });
      return;
    }

    const aplicado = await aplicarCambioDeRegimen({
      formRef: this.formRef,
      esAsimiladoNuevo: seraAsimilado,
      asimilados,
      todasConceptos,
      conceptosGlobalesIds,
    });

    if (!aplicado) {
      // Se revierte el select: dejar el régimen puesto con los conceptos viejos es
      // justamente el estado que el guardado rechaza.
      this.formRef.current.setFieldsValue({ tipoRegimenId: this.state.tipoRegimenIdPrevio });
      return;
    }

    this.setState({ esAsimilado: seraAsimilado, tipoRegimenIdPrevio: value });
  };

  // El check "incluir en cada nómina" es derivado: prende y apaga la percepción dentro de
  // conceptosIds, que es el mismo hecho. Ver Empleados/conceptosAsimilados.js.
  onCambiarIncluirAsimilados = (incluir) => {
    const percepcionId = this.state.asimilados?.percepcionId;
    if (!percepcionId) return;
    const actuales = this.formRef.current.getFieldValue("conceptosIds") || [];
    this.formRef.current.setFieldsValue({
      conceptosIds: alternarPercepcion(actuales, percepcionId, incluir),
    });
  };

  onChangeEstado(value, inicial) {
    if (!inicial) { this.formRef.current.setFieldsValue({ municipioId: undefined, coloniaId: undefined }); this.setState({ objetoMunicipios: null, objetoColonias: null }); }
    axios.post("municipios/selectMunicipios", { estadoId: value }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ todasMunicipios: res.data, objetoMunicipios: res.data.map((v) => <Option value={v._id} key={v._id}>{v.nombre}</Option>) }); });
  }

  onChangeMunicipio(value, inicial) {
    if (!inicial) { this.formRef.current.setFieldsValue({ coloniaId: undefined }); this.setState({ objetoColonias: null }); }
    axios.post("colonias/selectColonias", { municipioId: value }, { headers: this.props.headersToken })
      .then((res) => { if (res.data.status !== 404) this.setState({ todasColonias: res.data, objetoColonias: res.data.map((v) => <Option value={v._id} key={v._id}>{v.cp + " - " + v.nombre}</Option>) }); });
  }

  onSearchColonia(value) {
    if (value.toString().length === 5) {
      axios.post("colonias/buscarCP", { cp: value }, { headers: this.props.headersToken })
        .then((res) => {
          if (res.data.status === 404) { message.info("No se encontró el código postal"); }
          else { this.formRef.current.setFieldsValue({ paisId: res.data.paisId, estadoId: res.data.estadoId, municipioId: res.data.municipioId, coloniaId: res.data.colonias && res.data.colonias.length > 0 ? res.data.colonias[0]._id : undefined }); this.onChangeEstado(res.data.estadoId, true); this.onChangeMunicipio(res.data.municipioId, true); }
        });
    }
  }

  onSelectColoniaId(coloniaId) {
    const colonia = this.formRef.current.getFieldValue("colonia");
    if (!colonia) { const nombre = this.state.todasColonias.find((c) => c._id.toString() === coloniaId.toString())?.nombre; this.formRef.current.setFieldsValue({ colonia: nombre }); }
  }

  // ── F10: Calcular SBC ────────────────────────────────────────────────────
  // El cálculo vive en Pages/Panel/Empleados/sbc.js, compartido con Editar Empleado, Aumento de
  // Sueldo y —como gemelo— con Utils/prestaciones.utils.js del backend, que es quien pinta la
  // columna SBC del listado y corre la revisión automática.
  calcularSBC() {
    const vals = this.formRef.current.getFieldsValue();
    const { tipoPrestacionId, fechaAlta, fechaReingreso, salarioDiario } = vals;

    if (!tipoPrestacionId) {
      message.warning("Selecciona un Tipo de Prestación antes de calcular el SBC.");
      return;
    }

    const tipoPrestacion = this.state.todasTiposPrestacion.find(
      (t) => t._id.toString() === tipoPrestacionId.toString()
    );
    if (!tipoPrestacion) {
      message.error("No se encontró el Tipo de Prestación seleccionado.");
      return;
    }

    // A propósito NO se le pasa `baseDeCotizacion`: la revisión automática deja fuera a los de
    // salario variable puro, pero este botón es una petición explícita y debe calcular.
    const { sbc, anios, factor, motivo } = calcularSbcParteFija({
      empleado: { fechaAlta, fechaReingreso },
      tipoPrestacion,
      salarioDiario,
    });

    if (!sbc) {
      if (motivo === "sinFilaAplicable") {
        message.warning(`Con ${anios} año(s) de antigüedad no hay fila aplicable en la tabla "${tipoPrestacion.nombre}". Verifica que la tabla cubra esa antigüedad.`);
      } else {
        message.warning(MOTIVO_SBC_TEXTO[motivo] || "No se pudo calcular el SBC.");
      }
      return;
    }

    const topado = this.sbcTopado(sbc, vals.sbcParteVariable);
    this.formRef.current.setFieldsValue({ sbcParteFija: sbc, ...(topado !== null ? { sbcTopado25UMAS: topado } : {}) });
    message.success(`SBC calculado: $${sbc} (Antigüedad: ${anios} año(s), Factor: ${factor})`, 4);
  }

  // ── SBC automático ─────────────────────────────────────────────────────────
  // Mismo mecanismo que Editar Empleado. Al capturar el salario diario (o cambiar la prestación,
  // las fechas o la base de cotización) el SBC se calcula solo, con la misma fórmula de F10. A
  // diferencia de F10 aquí SÍ se le pasa `baseDeCotizacion`: a un salario variable puro no se le
  // pisa la parte fija en silencio. Va con un retraso corto para no recalcular en cada tecla.
  onValoresCambiados = (cambiados) => {
    if (!this.props.nomina) return;
    const claves = Object.keys(cambiados || {});
    const conParteFija = claves.some((k) => CAMPOS_SBC_PARTE_FIJA.includes(k));
    if (!conParteFija && !claves.some((k) => CAMPOS_SBC_TOPADO.includes(k))) return;
    this.sbcConParteFija = this.sbcConParteFija || conParteFija;
    clearTimeout(this.timerSbc);
    this.timerSbc = setTimeout(() => {
      const conFija = this.sbcConParteFija;
      this.sbcConParteFija = false;
      this.recalcularSbc(conFija);
    }, 400);
  };

  // Si hay un recálculo pendiente (se tecleó el sueldo y se guardó de inmediato), lo corre ya.
  // Regresa true si corrió, para que quien guarda vuelva a leer el SBC del formulario.
  correrSbcPendiente() {
    if (!this.timerSbc) return false;
    clearTimeout(this.timerSbc);
    this.timerSbc = null;
    const conFija = this.sbcConParteFija;
    this.sbcConParteFija = false;
    this.recalcularSbc(conFija);
    return true;
  }

  recalcularSbc(conParteFija) {
    this.timerSbc = null;
    const form = this.formRef.current;
    if (!form) return;
    const vals = form.getFieldsValue();
    let fija = Number(vals.sbcParteFija) || 0;
    const cambios = {};

    if (conParteFija) {
      const tipoPrestacion = this.state.todasTiposPrestacion.find(
        (t) => String(t._id) === String(vals.tipoPrestacionId)
      );
      const { sbc, anios, factor, motivo } = calcularSbcParteFija({
        empleado: { fechaAlta: vals.fechaAlta, fechaReingreso: vals.fechaReingreso, baseDeCotizacion: vals.baseDeCotizacion },
        tipoPrestacion,
        salarioDiario: vals.salarioDiario,
      });
      if (sbc) {
        fija = sbc;
        cambios.sbcParteFija = sbc;
        this.setState({ sbcAuto: `Calculado: salario × factor ${factor} (${anios} año(s) en la tabla)` });
      } else {
        this.setState({ sbcAuto: `No se calculó solo: ${MOTIVO_SBC_TEXTO[motivo] || "faltan datos"}` });
      }
    }

    const topado = this.sbcTopado(fija, vals.sbcParteVariable);
    if (topado !== null) cambios.sbcTopado25UMAS = topado;
    if (Object.keys(cambios).length) form.setFieldsValue(cambios);
  }

  // SBC topado a 25 UMAs = fija + variable con ese tope, igual que el motor de nómina. Sin UMA en
  // las tablas de nómina no se topa (el motor tampoco). null = no hay de qué calcularlo.
  sbcTopado(fija, variable) {
    const base = (Number(fija) || 0) + (Number(variable) || 0);
    if (base <= 0) return null;
    const uma = Number(this.state.umaVigente) || 0;
    return redondear2(uma > 0 ? Math.min(base, 25 * uma) : base);
  }

  onFinishFailed(e) { ErrorItem(e); }

  // ── Archivos de los documentos del empleado ────────────────────────────────
  beforeUploadDocumento = (file, rowName) => {
    if (!TIPOS_ARCHIVO_DOCUMENTOS.includes(file.type)) {
      message.error(`${file.name} debe ser un PDF o una imagen (jpg, png, webp)`);
      return Upload.LIST_IGNORE;
    }
    if (file.size / 1024 / 1024 >= 10) {
      message.error(`${file.name} excede el tamaño máximo de 10MB`);
      return Upload.LIST_IGNORE;
    }
    const documentos = this.formRef.current.getFieldValue("documentos") || [];
    const esteRenglonYaTiene = documentos[rowName]?.archivo?.length > 0;
    const totalConArchivo = documentos.filter((d) => d?.archivo?.length > 0).length;
    if (!esteRenglonYaTiene && totalConArchivo >= MAX_ARCHIVOS_DOCUMENTOS) {
      message.error(`Solo se permiten ${MAX_ARCHIVOS_DOCUMENTOS} archivos por empleado`);
      return Upload.LIST_IGNORE;
    }
    return false; // no se sube, se queda en el fileList hasta guardar
  };

  handlePreviewDocumento = (file) => { this.setState({ currentPreviewFile: file, filePreviewVisible: true }); };
  handleCloseFilePreview = () => { this.setState({ filePreviewVisible: false, currentPreviewFile: null }); };

  // Convierte el fileList de cada documento al { name, url } que espera el backend
  async archivosDocumentosParaGuardar(documentos) {
    return Promise.all(
      documentos.map(async (doc) => {
        const item = doc?.archivo?.[0];
        if (!item) return { ...doc, archivo: null };
        if (item.originFileObj instanceof Blob) {
          return { ...doc, archivo: { name: item.name, url: await getBase64(item.originFileObj) } };
        }
        return { ...doc, archivo: { name: item.name, url: item.urlRelativa } };
      })
    );
  }

  async onFinish(values) {
    // Un SBC automático que no alcanzó a correr se aplica antes de armar lo que se guarda.
    if (this.correrSbcPendiente()) {
      values = { ...values, ...this.formRef.current.getFieldsValue(["sbcParteFija", "sbcTopado25UMAS"]) };
    }
    this.setState({ loading: true });
    const datosFinales = { ...values, empresaId: this.props.empresaId };
    // Fechas-día como "YYYY-MM-DD" para que el backend las ancle al mediodía y no se puedan leer
    // un día corridas. Ver Components/fmtFechaDia.js.
    datosFinales.fechaAlta = fechaDiaParaPayload(values.fechaAlta);
    datosFinales.fechaReingreso = fechaDiaParaPayload(values.fechaReingreso);
    if (!datosFinales.documentos) datosFinales.documentos = [];
    if (!datosFinales.telefonos) datosFinales.telefonos = [];
    if (!datosFinales.contactosEmergencia) datosFinales.contactosEmergencia = [];
    datosFinales.documentos = await this.archivosDocumentosParaGuardar(datosFinales.documentos);
    if (datosFinales.chofer) datosFinales.documentos.unshift({ descripcion: datosFinales.numLicencia || "Licencia", tipo: "Licencia de Chofer", vencimiento: datosFinales.vigenciaLicencia });
    axios.post("empleados/agregarEmpleado", datosFinales, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) { message.success("Empleado agregado exitosamente"); this.formRef.current.resetFields(); this.atras(); }
        else { message.error(res.data.message || "Sucedió un error y no se guardó"); }
      });
  }

  // ── Primer tab: campos de General + campos de nómina si aplica ─────────────
  renderPrimerTab() {
    const { nomina } = this.props;
    return (
      <>
        {(!nomina || this.props.modulosMezcal) && (
          <Row gutter={24}>
            {!nomina && (
              <Col span={12}>
                <FormItem name="externo" label="Externo" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP} tooltip="Al activar, la persona no contará para efectos de la empresa">
                  <SwitchItem />
                </FormItem>
              </Col>
            )}
            {this.props.modulosMezcal && (
              <Col span={12}>
                <FormItem name="responsableMezcal" label="Resp. Mezcal" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
              </Col>
            )}
          </Row>
        )}
        <Row gutter={24}>
          <Col span={12}>
            <FormItem name="extranjero" label="Extranjero" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => getFieldValue("extranjero") && (
                <>
                  <FormItem label="N° Reg. ID Tributario" name="registroIDTributario" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="N° Registro ID Tributario" /></FormItem>
                  <FormItem label="Residencia Fiscal" name="paisResidenciaId" margin required labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Residencia Fiscal">{this.state.objetoPaisesResidencia}</SelectItem></FormItem>
                </>
              )}
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem name="chofer" label="Chofer" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
            <FormItem shouldUpdate noStyle>
              {({ getFieldValue }) => getFieldValue("chofer") && (
                <>
                  <FormItem label="Figura Transporte" name="figuraTransporteId" margin required labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Figura Transporte">{this.state.objetoFigurasTranporte}</SelectItem></FormItem>
                  <FormItem label="N° Licencia" name="numLicencia" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="N° Licencia" /></FormItem>
                  <FormItem label="Vigencia Licencia" name="vigenciaLicencia" margin required labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Vigencia" /></FormItem>
                </>
              )}
            </FormItem>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <FormItem label="Departamento" name="departamentoId" margin labelCol={LBL} wrapperCol={WRP}>
              <SelectDepartamentosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Departamento" onChange={(v) => this.formRef.current.setFieldsValue({ departamentoId: v })} />
            </FormItem>
          </Col>
          <Col span={12}>
            <FormItem label="Puesto" name="puestoId" margin labelCol={LBL} wrapperCol={WRP}>
              <SelectPuestosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Puesto" onChange={(v) => this.formRef.current.setFieldsValue({ puestoId: v })} />
            </FormItem>
          </Col>
        </Row>
        {nomina && (
          <>
            <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 4 }}>Nómina</Divider>
            <Row gutter={24}>
              <Col span={12}>
                <FormItem label="Tipo Prestación" name="tipoPrestacionId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de Prestación">{this.state.objetoTiposPrestacion}</SelectItem></FormItem>
                <FormItem label="Base de Pago" name="basePago" margin labelCol={LBL} wrapperCol={WRP}>
                  <SelectItem placeholder="Base de pago"><Option value={1}>Sueldo</Option><Option value={2}>Comisión</Option><Option value={3}>Destajo</Option><Option value={4}>Sueldo-Comisión</Option><Option value={5}>Sueldo-Destajo</Option></SelectItem>
                </FormItem>
                <FormItem label="Forma de Pago" name="formaDePagoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Forma de pago">{this.state.objetoFormasDePago}</SelectItem></FormItem>
                <FormItem label="Turno de Trabajo" name="turnoId" margin labelCol={LBL} wrapperCol={WRP}>
                  <SelectTurnosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Turno de trabajo" onChange={(v) => this.formRef.current.setFieldsValue({ turnoId: v })} />
                </FormItem>
                <FormItem label="Tipo de Jornada" name="tipoJornadaId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de jornada">{this.state.objetoTiposJornada}</SelectItem></FormItem>
                <FormItem label="Régimen Fiscal" name="regimenFiscalId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Régimen fiscal">{this.state.objetoRegimenFiscal}</SelectItem></FormItem>
                <FormItem label="Tipo de Régimen" name="tipoRegimenId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de régimen" onChange={this.onCambiarTipoRegimen}>{this.state.objetoTipoRegimen}</SelectItem></FormItem>
              </Col>
              <Col span={12}>
                <FormItem label="N° FONACOT" name="numeroFONACOT" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="N° FONACOT" min={0} /></FormItem>
                <FormItem label="AFORE" name="afore" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="AFORE" min={0} /></FormItem>
                <FormItem label="Expediente" name="expediente" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Expediente" /></FormItem>
                <FormItem label="Líder Directo" name="liderDirectoId" margin labelCol={LBL} wrapperCol={WRP}>
                  <SelectEmpleadosItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Líder directo" onChange={(v) => this.formRef.current.setFieldsValue({ liderDirectoId: v })} />
                </FormItem>
              </Col>
            </Row>
          </>
        )}
      </>
    );
  }

  render() {
    const { nomina, controlAsistencia } = this.props;
    const thStyle = {
      border: "1px solid gray",
      background: "var(--color-background-secondary)",
      padding: "6px 10px",
      fontSize: 12,
      fontWeight: 500,
      color: "var(--color-text-secondary)",
      textAlign: "left",
    };
    const tdStyle = {
      border: "1px solid gray",
      padding: "4px 8px",
      verticalAlign: "middle",
    };
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Agregar Empleado"
          className="captura-empleado-cabecera"
          avatar={{ icon: <UserOutlined /> }}
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
        />
        {/* Estilo de captura compartido con Editar Empleado y el alta por pasos (../capturaEmpleado.css). */}
        <div className="captura-empleado captura-empleado-tarjeta" style={{ backgroundColor: "white", paddingLeft: 20, paddingRight: 20 }}>
          <Spin spinning={this.state.loading}>
            <Form ref={this.formRef} name="agregarEmpleado" layout
              bottom={<ButtonItem htmlType="submit" cyan style={{ display: "block", margin: "0 0 0 auto" }}>Guardar Empleado</ButtonItem>}
              onFinish={this.onFinish.bind(this)} onFinishFailed={this.onFinishFailed} onValuesChange={this.onValoresCambiados}>

              {/* ENCABEZADO */}
              <div className="captura-empleado-encabezado">
                <Row gutter={24} align="top" wrap={false}>
                  <Col flex="170px" className="captura-empleado-foto">
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 6 }}>
                      {/* noStyle: sin la rejilla etiqueta/campo del formulario, que la hacía más
                          ancha que su columna. Sigue ligada al campo `fotoRostro`. */}
                      <FormItem name="fotoRostro" noStyle>
                        <FotoRostroEmpleado />
                      </FormItem>
                    </div>
                  </Col>
                  <Col span={11}>
                    <FormItem label="Código" name="codigo" margin required labelCol={LBL} wrapperCol={WRP} getValueFromEvent={soloDigitos}><InputItem placeholder="Código empleado" inputMode="numeric" /></FormItem>
                    <FormItem label="Nombre(s)" name="nombre" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Nombre(s)" /></FormItem>
                    <FormItem label="Ap. Paterno" name="apellidoPaterno" margin pattern required labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Apellido Paterno" /></FormItem>
                    <FormItem label="Ap. Materno" name="apellidoMaterno" margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Apellido Materno" /></FormItem>
                    <FormItem label="RFC" name="rfc" margin rfc labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="RFC" suffix={<CalculadoraRfc obtenerForm={() => this.formRef.current} />} /></FormItem>
                    <FormItem label="CURP" name="curp" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="CURP" suffix={<CalculadoraCurp obtenerForm={() => this.formRef.current} />} /></FormItem>
                    <FormItem label="Correo" name="correoElectronico" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="correo@empresa.com" /></FormItem>
                  </Col>
                  <Col span={11}>
                    {/* Arranca en hoy: sin fecha de alta no hay antigüedad y el SBC no se calcula solo. */}
                    <FormItem label="Fecha Alta" name="fechaAlta" margin initialValue={moment()} labelCol={LBL} wrapperCol={WRP}><DatePickerItem placeholder="Fecha de alta" style={{ width: "100%" }} /></FormItem>
                    {/* Se captura también en el alta para que este formulario no se desincronice
                        de Editar Empleado. Casi siempre va vacío: sólo aplica cuando se está dando
                        de alta a alguien que ya había trabajado aquí. */}
                    <FormItem
                      label="Fecha Reingreso" name="fechaReingreso" margin
                      labelCol={LBL} wrapperCol={WRP}
                      tooltip="Sólo si el empleado ya había trabajado aquí antes. Si es posterior a la fecha de alta, ÉSTA es la que se usa como inicio de la relación laboral en el CFDI de nómina, el recibo, el aguinaldo y el finiquito."
                    >
                      <DatePickerItem placeholder="Sin reingreso" style={{ width: "100%" }} allowClear />
                    </FormItem>
                    {nomina && (
                      <>
                        <FormItem label="Tipo Contrato" name="tipoContratoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de contrato">{this.state.objetoTiposContrato}</SelectItem></FormItem>
                        <FormItem label="Tipo Periodo" name="tipoPeriodoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Tipo de periodo" allowClear>{this.state.objetoTiposPeriodo}</SelectItem></FormItem>
                        <FormItem label="Salario Diario" name="salarioDiario" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                        <FormItem label="Base Cotización" name="baseDeCotizacion" margin labelCol={LBL} wrapperCol={WRP}>
                          <SelectItem placeholder="Base de cotización"><Option value={1}>Sueldo</Option><Option value={2}>Comisión</Option><Option value={3}>Destajo</Option><Option value={4}>Sueldo-Comisión</Option><Option value={5}>Sueldo-Destajo</Option></SelectItem>
                        </FormItem>
                        <FormItem label="NSS" name="numSeguridadSocial" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="N° Seguridad Social" /></FormItem>
                      </>
                    )}
                  </Col>
                </Row>
                {nomina && (
                  <Row gutter={24} className="captura-empleado-sbc" style={{ marginTop: 10, borderTop: "1px solid #f0f0f0", paddingTop: 10 }}>
                    <Col span={11} offset={1}>
                      <Row gutter={16}>
                        <Col span={12}><FormItem label="SBC Fija" name="sbcParteFija" margin labelCol={LBL} wrapperCol={WRP}
                          extra={this.state.sbcAuto ? <span style={{ fontSize: 11 }}>{this.state.sbcAuto}</span> : undefined}
                          tooltip="Se calcula solo al capturar el salario diario: salario × factor de integración de su tipo de prestación. F10 lo recalcula."><InputNumberItem placeholder="0.00" min={0} /></FormItem></Col>
                        <Col span={12}><FormItem label="SBC Variable" name="sbcParteVariable" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem></Col>
                      </Row>
                    </Col>
                    <Col span={11}>
                      <Row gutter={16}>
                        <Col span={12}><FormItem label="SBC (25 UMAS)" name="sbcTopado25UMAS" margin labelCol={LBL} wrapperCol={WRP}
                          tooltip={`Se calcula solo: SBC fija + variable, con tope de 25 UMAs${this.state.umaVigente ? ` (UMA $${this.state.umaVigente})` : ""}. F10 lo recalcula.`}>
                          <InputNumberItem placeholder="0.00" min={0} /></FormItem></Col>
                        <Col span={6}><FormItem name="externo" label="Externo" margin initialValue={false} valuePropName="checked"><SwitchItem /></FormItem></Col>
                        <Col span={6}><FormItem name="sindicalizado" label="Sind." margin initialValue={false} valuePropName="checked"><SwitchItem /></FormItem></Col>
                      </Row>
                    </Col>
                  </Row>
                )}
              </div>

              {/* TABS */}
              <Tabs defaultActiveKey="1">

                {/* PRIMER TAB: "Generales" si nomina, "General" si no */}
                <TabPane tab={nomina ? "Generales" : "General"} key="1" forceRender>
                  {this.renderPrimerTab()}
                </TabPane>

                {/* Domicilio */}
                <TabPane tab="Domicilio" key="2" forceRender>
                  <Row gutter={24}>
                    <Col span={12}>
                      <FormItem label="Código Postal" name="coloniaId" margin labelCol={LBL} wrapperCol={WRP}>
                        <SelectItem placeholder="Colonia" onSearch={this.onSearchColonia.bind(this)} onSelect={this.onSelectColoniaId.bind(this)}>
                          {this.state.objetoColonias === null ? <Option disabled>Elija primero un municipio</Option> : this.state.objetoColonias}
                          <Option disabled>Busque por código postal</Option>
                        </SelectItem>
                      </FormItem>
                      <FormItem label="Municipio" name="municipioId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Municipio" onChange={this.onChangeMunicipio.bind(this)}>{this.state.objetoMunicipios === null ? <Option disabled>Elija primero un estado</Option> : this.state.objetoMunicipios}</SelectItem></FormItem>
                      <FormItem label="Estado" name="estadoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Estado" onChange={this.onChangeEstado.bind(this)}>{this.state.objetoEstados}</SelectItem></FormItem>
                      <FormItem label="País" name="paisId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="País">{this.state.objetoPaises}</SelectItem></FormItem>
                    </Col>
                    <Col span={12}>
                      <FormItem name="colonia" label="Colonia" margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Colonia" /></FormItem>
                      <FormItem label="Calle" name="calle" max={200} margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Calle" /></FormItem>
                      <FormItem label="Número" name="numeroCalle" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Número" numeroCalle /></FormItem>
                      <FormItem label="Núm. Interior" name="numeroInterior" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Número Interior" numeroCalle /></FormItem>
                      <FormItem label="Referencia" name="referencia" margin pattern labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Referencia" /></FormItem>
                    </Col>
                  </Row>
                </TabPane>

                {/* Tabs de nómina */}
                {nomina && (
                  <>
                    <TabPane tab="IMSS - Infonavit" key="4" forceRender>
                      <Row gutter={24}>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Datos IMSS</Divider>
                          <FormItem label="N° Seg. Social" name="numSeguridadSocial" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="NSS" /></FormItem>
                          <FormItem label="Registro Patronal" name="registroPatronalId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Registro patronal">{this.state.objetoRegistrosPatronales}</SelectItem></FormItem>
                          <FormItem label="UMF" name="umf" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="UMF" /></FormItem>
                          <FormItem label="Nombre del Padre" name="nombrePadre" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Nombre del padre" /></FormItem>
                          <FormItem label="Nombre de la Madre" name="nombreMadre" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Nombre de la madre" /></FormItem>
                          <FormItem label="Estado Civil" name="estadoCivil" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Estado civil"><Option value={1}>Soltero</Option><Option value={2}>Casado</Option><Option value={3}>Concubinato</Option><Option value={4}>Unión Civil</Option><Option value={5}>Viudo</Option><Option value={6}>Divorciado</Option></SelectItem></FormItem>
                          <FormItem label="Avisos Pendientes" name="avisosPendientes" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Avisos pendientes"><Option value="alta">Alta</Option><Option value="baja">Baja</Option><Option value="modifSalario">Modificación de Salario</Option></SelectItem></FormItem>
                          <FormItem label="Última Baja" name="ultimaBaja" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Última baja" /></FormItem>
                        </Col>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Datos Personales</Divider>
                          <FormItem label="Sexo" name="sexo" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Sexo"><Option value="Hombre">Hombre</Option><Option value="Mujer">Mujer</Option><Option value="No Aplica">No Aplica</Option></SelectItem></FormItem>
                          <FormItem label="Fecha Nacimiento" name="fechaNacimiento" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Fecha de nacimiento" /></FormItem>
                          <FormItem label="Estado Nacimiento" name="estadoNacimientoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Estado de nacimiento">{this.state.objetoEstadosNacimiento}</SelectItem></FormItem>
                          <FormItem label="Ciudad Nacimiento" name="ciudadNacimientoId" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Ciudad de nacimiento" /></FormItem>
                          <FormItem label="CURP" name="curp" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="CURP" suffix={<CalculadoraCurp obtenerForm={() => this.formRef.current} />} /></FormItem>
                          <FormItem name="extranjeroSinCurp" label="Sin CURP" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}><SwitchItem /></FormItem>
                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane tab="Sueldos y Salarios" key="5" forceRender>
                      <Row gutter={24}>
                        <Col span={12}>
                          <FormItem label="Salario Variable" name="salarioVariable" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                          <FormItem label="Fecha Sal. Variable" name="fechaSalarioVariable" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                          <FormItem label="Salario Promedio" name="salarioPromedio" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                          <FormItem label="Fecha Sal. Promedio" name="fechaSalarioPromedio" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem label="Sal. Base Liquid." name="salarioBaseLiquidacion" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" min={0} /></FormItem>
                          <FormItem label="Saldo Ajuste Neto" name="saldoAjusteNeto" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0.00" /></FormItem>
                          <FormItem label="Fecha Sal. Diario" name="fechaSalarioDiario" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                          <FormItem label="Fecha Sal. Integrado" name="fechaSalarioIntegrado" margin labelCol={LBL} wrapperCol={WRP}><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" /></FormItem>
                        </Col>
                      </Row>
                    </TabPane>

                    <TabPane tab="Pagos y Extras" key="6" forceRender>
                      <Row gutter={24}>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Pagos Bancarios</Divider>
                          <FormItem label="Banco" name="bancoPagoElectronicoId" margin labelCol={LBL} wrapperCol={WRP}><SelectItem placeholder="Banco">{this.state.objetoBancos}</SelectItem></FormItem>
                          <FormItem label="Sucursal" name="sucursalPagoElectronico" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Sucursal" /></FormItem>
                          <FormItem label="N° Cuenta" name="numCuenta" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Número de cuenta" /></FormItem>
                          <FormItem label="CLABE" name="clabeInterbancaria" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="CLABE 18 dígitos" /></FormItem>
                        </Col>
                        <Col span={12}>
                          <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Extras</Divider>
                          <FormItem label="Extra 1" name="extra1" margin labelCol={LBL} wrapperCol={WRP}><InputItem placeholder="Extra 1" /></FormItem>
                          <FormItem label="Núm. Extra 1" name="numExtra1" margin labelCol={LBL} wrapperCol={WRP}><InputNumberItem placeholder="0" /></FormItem>
                        </Col>
                      </Row>
                    </TabPane>

                    {/* forceRender NO se puede quitar: sin él el Form.List de conceptosIds
                        no se monta, no viaja en los values del submit y el reemplazo por
                        régimen se vuelve un no-op silencioso (el empleado quedaría como
                        asimilado conservando Sueldo e IMSS). */}
                    <TabPane tab="Conceptos" key="9" forceRender>
                      {this.state.esAsimilado && (
                        <Alert
                          type="info"
                          showIcon
                          style={{ marginBottom: 12 }}
                          message="Empleado asimilado a salarios"
                          description="No le corresponden Sueldo, Séptimo Día, cuotas del IMSS ni subsidio al empleo. Los conceptos de ISR de la lista son los que calculan su retención: si los quitas, el impuesto sale mal."
                        />
                      )}
                      {/* PTU y Aguinaldo */}
                      <Row gutter={24} style={{ marginBottom: 4 }}>
                        <Col span={12}>
                          <FormItem name="calculoPTU" label="Cálculo PTU" margin initialValue={true} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}
                            tooltip="Al activar, este empleado participará en el cálculo de PTU">
                            <SwitchItem />
                          </FormItem>
                        </Col>
                        <Col span={12}>
                          <FormItem name="calculoAguinaldo" label="Cálculo Aguinaldo" margin initialValue={true} valuePropName="checked" labelCol={LBL} wrapperCol={WRP}
                            tooltip="Al activar, se calculará aguinaldo para este empleado">
                            <SwitchItem />
                          </FormItem>
                        </Col>
                      </Row>

                      {this.state.esAsimilado && this.state.asimilados?.percepcionId && (
                        <Row gutter={24} style={{ marginBottom: 4 }}>
                          <Col span={12}>
                            {/* Derivado de conceptosIds, no es un campo del empleado: va sin
                                `name` y con su propio onChange. El shouldUpdate es lo que lo
                                vuelve a pintar cuando la lista cambia — setFieldsValue no
                                re-renderiza el componente por sí solo. */}
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => (
                                <FormItem
                                  label="Ingreso en cada nómina"
                                  margin
                                  labelCol={LBL}
                                  wrapperCol={WRP}
                                  tooltip="Activado, el concepto de ingreso de asimilados entra solo en cada nómina que se abra (con importe en cero, para que lo captures). Desactivado, hay que agregarlo a mano en el sobre-recibo cada vez que se le pague."
                                >
                                  <SwitchItem
                                    checked={percepcionIncluida(
                                      getFieldValue("conceptosIds"),
                                      this.state.asimilados.percepcionId
                                    )}
                                    onChange={this.onCambiarIncluirAsimilados}
                                  />
                                </FormItem>
                              )}
                            </FormItem>
                          </Col>
                        </Row>
                      )}

                      <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>
                        Conceptos asignados al empleado
                      </Divider>

                      <Form.List name="conceptosIds">
                        {(fields, { add, remove, move }) => (
                          <>
                            <table style={{ width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
                              <colgroup>
                                <col />
                                <col style={{ width: 96 }} />
                                <col style={{ width: 108 }} />
                                <col style={{ width: 52 }} />
                                <col style={{ width: 36 }} />
                              </colgroup>
                              <thead>
                                <tr>
                                  <th style={thStyle}>Concepto</th>
                                  <th style={{ ...thStyle, textAlign: "center" }}>Clave</th>
                                  <th style={{ ...thStyle, textAlign: "center" }}>Tipo</th>
                                  <th style={thStyle} />
                                  <th style={thStyle} />
                                </tr>
                              </thead>
                              <tbody>
                                {fields.length === 0 ? (
                                  <tr>
                                    {/* Para un asimilado esto no es un estado neutro: "todos"
                                        incluye Sueldo e IMSS, que no le corresponden. El
                                        guardado lo rechaza, y aquí se avisa antes. */}
                                    <td colSpan={5} style={{ ...tdStyle, textAlign: "center", padding: "18px 0", color: this.state.esAsimilado ? "#a8071a" : "var(--color-text-secondary)", fontSize: 12 }}>
                                      {this.state.esAsimilado ? (
                                        <>
                                          Sin conceptos — a un asimilado a salarios <strong>no</strong> se le puede dejar la lista vacía:
                                          significa <strong>todos</strong> los conceptos, Sueldo e IMSS incluidos. Vuelve a elegir su
                                          Tipo de Régimen en Generales para que se le propongan.
                                        </>
                                      ) : (
                                        <>Sin conceptos — al calcular se usarán <strong>todos</strong> los activos de la empresa</>
                                      )}
                                    </td>
                                  </tr>
                                ) : (
                                  fields.map(({ key, name, ...restField }, index) => (
                                    <FormItem key={key} shouldUpdate noStyle>
                                      {({ getFieldValue }) => {
                                        const conceptoId = getFieldValue(["conceptosIds", name]);
                                        const concepto = this.state.todasConceptos.find(c => c._id?.toString() === conceptoId?.toString());
                                        const tipoCfg = {
                                          1: { label: "Percepción", color: "#3B6D11", bg: "#EAF3DE" },
                                          2: { label: "Deducción", color: "#A32D2D", bg: "#FCEBEB" },
                                          3: { label: "Obligación", color: "#185FA5", bg: "#E6F1FB" },
                                        };
                                        const tipo = tipoCfg[concepto?.tipo];
                                        const deshabilitado = concepto && concepto.estado !== 1;
                                        const rowBg = deshabilitado ? "#FAEEDA30" : "var(--color-background-primary)";
                                        return (
                                          <tr style={{ background: rowBg }}>
                                            {/* Concepto */}
                                            <td style={{ ...tdStyle, padding: "2px 4px" }}>
                                              <FormItem {...restField} name={name} noStyle required>
                                                <SelectItem placeholder="Seleccionar concepto..." showSearch width="100%"
                                                  filterOption={(input, option) =>
                                                    option?.children?.toLowerCase().includes(input.toLowerCase())
                                                  }>
                                                  {this.state.todasConceptos.filter(c => c.estado === 1).map(c => (
                                                    <Option value={c._id} key={c._id}>
                                                      {c.serie + "-" + c.numero + " | " + c.descripcion}
                                                    </Option>
                                                  ))}
                                                </SelectItem>
                                              </FormItem>
                                            </td>
                                            {/* Clave */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              {concepto ? (
                                                <span style={{ fontFamily: "monospace", fontSize: 11, background: "var(--color-background-secondary)", border: "1px solid var(--color-border-tertiary)", borderRadius: 4, padding: "2px 7px", color: "var(--color-text-secondary)" }}>
                                                  {concepto.serie + "-" + concepto.numero}
                                                </span>
                                              ) : <span style={{ color: "var(--color-text-secondary)", fontSize: 12 }}>—</span>}
                                            </td>
                                            {/* Tipo */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              {tipo ? (
                                                <span style={{ fontSize: 11, fontWeight: 500, padding: "2px 9px", borderRadius: 999, background: tipo.bg, color: tipo.color }}>
                                                  {tipo.label}
                                                </span>
                                              ) : deshabilitado ? (
                                                <span style={{ fontSize: 11, fontWeight: 500, padding: "2px 9px", borderRadius: 999, background: "#FAEEDA", color: "#854F0B" }}>
                                                  Deshabilitado
                                                </span>
                                              ) : <span style={{ color: "var(--color-text-secondary)", fontSize: 12 }}>—</span>}
                                            </td>
                                            {/* Reordenar */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
                                                <UpOutlined
                                                  style={{ fontSize: 11, color: index === 0 ? "#d9d9d9" : "var(--color-text-secondary)", cursor: index === 0 ? "not-allowed" : "pointer" }}
                                                  onClick={() => index > 0 && move(index, index - 1)}
                                                />
                                                <DownOutlined
                                                  style={{ fontSize: 11, color: index === fields.length - 1 ? "#d9d9d9" : "var(--color-text-secondary)", cursor: index === fields.length - 1 ? "not-allowed" : "pointer" }}
                                                  onClick={() => index < fields.length - 1 && move(index, index + 1)}
                                                />
                                              </div>
                                            </td>
                                            {/* Eliminar */}
                                            <td style={{ ...tdStyle, textAlign: "center" }}>
                                              <MinusCircleOutlined
                                                style={{ fontSize: 14, color: "var(--color-text-secondary)", cursor: "pointer" }}
                                                onMouseEnter={e => e.target.style.color = "#E24B4A"}
                                                onMouseLeave={e => e.target.style.color = ""}
                                                onClick={() => remove(name)}
                                              />
                                            </td>
                                          </tr>
                                        );
                                      }}
                                    </FormItem>
                                  ))
                                )}
                              </tbody>
                            </table>

                            <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}
                              style={{ marginTop: 8 }}
                              disabled={this.state.todasConceptos.filter(c => c.estado === 1).length === 0}>
                              Agregar concepto
                            </ButtonItem>
                          </>
                        )}
                      </Form.List>
                    </TabPane>
                  </>
                )}


                {/* Control Asistencia */}
                {controlAsistencia && (
                  <TabPane tab={<span><ScanOutlined /> Control Asistencia</span>} key="8" forceRender>
                    <div style={{ background: "#f6ffed", border: "1px solid #b7eb8f", borderRadius: 6, padding: 16, marginBottom: 20 }}>
                      <span style={{ color: "#52c41a", fontSize: 13 }}>Las credenciales del reloj checador se registran automáticamente al capturarlas en el dispositivo. Guarda primero al empleado para asociar sus credenciales.</span>
                    </div>
                    <Row gutter={24}>
                      <Col span={8}><CredencialCard icon={<EyeOutlined />} titulo="Reconocimiento Facial" activo={false} color="#1677ff" /></Col>
                      <Col span={8}><CredencialCard icon={<ScanOutlined />} titulo="Huella Digital" activo={false} color="#722ed1" /></Col>
                      <Col span={8}><CredencialCard icon={<LockOutlined />} titulo="Contraseña" activo={false} color="#fa8c16" /></Col>
                    </Row>
                    {this.props.appMovil && this.props.checadaRemota && (
                      <>
                        <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 20 }}>Checada remota (app)</Divider>
                        <Row gutter={24}>
                          <Col span={12}>
                            <FormItem name="permiteChecadaRemota" label="Permitir checada remota (app)" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP} tooltip="El empleado podrá registrar su entrada y salida desde la app móvil, solo dentro de los perímetros asignados">
                              <SwitchItem />
                            </FormItem>
                          </Col>
                          <Col span={12}>
                            <FormItem shouldUpdate noStyle>
                              {({ getFieldValue }) => getFieldValue("permiteChecadaRemota") && (
                                <FormItem label="Perímetros" name="perimetrosChecadaIds" margin labelCol={LBL} wrapperCol={WRP}
                                  rules={[{ required: true, type: "array", min: 1, message: "Selecciona al menos un perímetro de checada" }]}>
                                  <SelectPerimetrosChecadaItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} sinBorde width="100%" placeholder="Perímetros de checada" />
                                </FormItem>
                              )}
                            </FormItem>
                          </Col>
                        </Row>
                        {this.props.verificacionFacial && (
                          <Row gutter={24}>
                            <Col span={12}>
                              <FormItem shouldUpdate noStyle>
                                {({ getFieldValue }) => getFieldValue("permiteChecadaRemota") && (
                                  <FormItem name="verificacionFacialChecada" label="Verificar rostro al checar" margin initialValue={false} valuePropName="checked" labelCol={LBL} wrapperCol={WRP} tooltip="Al checar, la app compara la cara del empleado contra su fotografía. Sin fotografía cargada no podrá checar">
                                    <SwitchItem />
                                  </FormItem>
                                )}
                              </FormItem>
                            </Col>
                          </Row>
                        )}
                      </>
                    )}
                  </TabPane>
                )}

                {/* Contactos */}
                <TabPane tab="Contactos" key="10" forceRender>
                  <Divider orientation="left" plain style={{ fontSize: 12, color: "#888", marginTop: 0 }}>Teléfonos</Divider>
                  <Form.List name="telefonos">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={16} style={{ marginBottom: 8 }}>
                            <Col span={8}>
                              <FormItem {...restField} name={[name, "descripcion"]} label="Descripción" rules={[{ required: true, message: "Ingresa la descripción" }]}>
                                <InputItem placeholder="Ej. Celular, Trabajo" />
                              </FormItem>
                            </Col>
                            <Col span={12}>
                              <FormItem {...restField} name={[name, "numero"]} label="Número" rules={[{ required: true, message: "Ingresa el número" }]}>
                                <InputItem placeholder="Ej. 5512345678" />
                              </FormItem>
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                              <MinusCircleOutlined style={{ fontSize: 18, color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                            </Col>
                          </Row>
                        ))}
                        <Row style={{ marginBottom: 16 }}>
                          <Col span={24}>
                            <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>Añadir Teléfono</ButtonItem>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Form.List>

                  <Divider orientation="left" plain style={{ fontSize: 12, color: "#888" }}>Contactos de Emergencia</Divider>
                  <Form.List name="contactosEmergencia">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={16} style={{ marginBottom: 8 }}>
                            <Col span={8}>
                              <FormItem {...restField} name={[name, "nombre"]} label="Nombre" rules={[{ required: true, message: "Ingresa el nombre" }]}>
                                <InputItem placeholder="Nombre completo" />
                              </FormItem>
                            </Col>
                            <Col span={6}>
                              <FormItem {...restField} name={[name, "parentesco"]} label="Parentesco" rules={[{ required: true, message: "Ingresa el parentesco" }]}>
                                <InputItem placeholder="Ej. Esposa, Padre" />
                              </FormItem>
                            </Col>
                            <Col span={7}>
                              <FormItem {...restField} name={[name, "telefono"]} label="Teléfono" rules={[{ required: true, message: "Ingresa el teléfono" }]}>
                                <InputItem placeholder="Ej. 5512345678" />
                              </FormItem>
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                              <MinusCircleOutlined style={{ fontSize: 18, color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                            </Col>
                          </Row>
                        ))}
                        <Row>
                          <Col span={24}>
                            <ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ marginBottom: 10 }}>Añadir Contacto de Emergencia</ButtonItem>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Form.List>
                </TabPane>

                {/* Documentos */}
                <TabPane tab="Documentos" key="7" forceRender>
                  <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      if (getFieldValue("chofer")) {
                        return (
                          <>
                            <Row style={{ marginBottom: 10 }}><Col span={24}><Alert message="Datos obtenidos de la Licencia del Chofer" description="Para modificar esta información, favor de hacerlo en la pestaña General." type="info" showIcon /></Col></Row>
                            <Row gutter={16} style={{ marginBottom: 12, opacity: 0.8 }}>
                              <Col span={6}><FormItem label="Descripción" margin><InputItem disabled value={getFieldValue("numLicencia") || "Licencia"} /></FormItem></Col>
                              <Col span={5}><FormItem label="Tipo" margin><InputItem disabled value="Licencia de Chofer" /></FormItem></Col>
                              <Col span={5}><FormItem label="Vencimiento" margin><DatePickerItem disabled style={{ width: "100%" }} format="DD-MM-YYYY" value={getFieldValue("vigenciaLicencia")} /></FormItem></Col>
                            </Row>
                          </>
                        );
                      }
                      return null;
                    }}
                  </FormItem>
                  <Form.List name="documentos">
                    {(fields, { add, remove }) => (
                      <>
                        {fields.map(({ key, name, ...restField }) => (
                          <Row key={key} gutter={16} style={{ marginBottom: 12 }}>
                            <Col span={6}><FormItem {...restField} name={[name, "descripcion"]} label="Descripción" rules={[{ required: true, message: "Ingresa la descripción" }]}><InputItem placeholder="Ej. Licencia Estatal" /></FormItem></Col>
                            <Col span={5}><FormItem {...restField} name={[name, "tipo"]} label="Tipo" rules={[{ required: true, message: "Ingresa el tipo" }]}><InputItem placeholder="Ej. Apta Médica" /></FormItem></Col>
                            <Col span={5}><FormItem {...restField} name={[name, "vencimiento"]} label="Vencimiento"><DatePickerItem style={{ width: "100%" }} format="DD-MM-YYYY" placeholder="Fecha de vencimiento" /></FormItem></Col>
                            <Col span={6}>
                              <FormItem
                                {...restField}
                                name={[name, "archivo"]}
                                label="Archivo"
                                valuePropName="fileList"
                                getValueFromEvent={normFile}
                                tooltip={`PDF o imagen, máximo ${MAX_ARCHIVOS_DOCUMENTOS} archivos por empleado`}
                              >
                                <Upload
                                  accept=".pdf,.jpg,.jpeg,.png,.webp"
                                  maxCount={1}
                                  beforeUpload={(file) => this.beforeUploadDocumento(file, name)}
                                  onPreview={this.handlePreviewDocumento}
                                  showUploadList={{ showRemoveIcon: true, removeIcon: <DeleteOutlined style={{ color: "red" }} /> }}
                                >
                                  <FormItem noStyle shouldUpdate>
                                    {({ getFieldValue }) => {
                                      const documentos = getFieldValue("documentos") || [];
                                      if (documentos[name]?.archivo?.length > 0) return null;
                                      const totalConArchivo = documentos.filter((d) => d?.archivo?.length > 0).length;
                                      if (totalConArchivo >= MAX_ARCHIVOS_DOCUMENTOS) return null;
                                      return <ButtonItem type="dashed" size="small" icon={<UploadOutlined />}>Subir</ButtonItem>;
                                    }}
                                  </FormItem>
                                </Upload>
                              </FormItem>
                            </Col>
                            <Col span={2} style={{ display: "flex", alignItems: "center", paddingTop: 8 }}>
                              <MinusCircleOutlined style={{ fontSize: 18, color: "#ff4d4f", cursor: "pointer" }} onClick={() => remove(name)} />
                            </Col>
                          </Row>
                        ))}
                        <Row><Col span={24}><ButtonItem type="dashed" onClick={() => add()} block icon={<PlusOutlined />} style={{ marginTop: 10, marginBottom: 10 }}>Añadir Documento</ButtonItem></Col></Row>
                      </>
                    )}
                  </Form.List>
                </TabPane>

                {/*
                  Créditos y movimientos: sólo existen contra un empleado ya guardado, porque cada
                  uno es un documento aparte que se referencia por `empleadoId`. Se muestran igual
                  que el tab de Control Asistencia de arriba —en modo aviso, ni escondidas ni
                  deshabilitadas— para que se vea que la pantalla las tiene. La captura real está
                  en Editar Empleado.
                */}
                {[
                  { key: "12", tab: "Créditos INFONAVIT", soloNomina: true },
                  { key: "13", tab: "Créditos FONACOT", soloNomina: true },
                  { key: "14", tab: "Mov. Permanentes", soloNomina: true },
                  { key: "15", tab: "Incid. Permanentes", soloNomina: true },
                  { key: "16", tab: "Incapacidades", soloNomina: true },
                  { key: "17", tab: "Vacaciones", soloNomina: false },
                ]
                  .filter((t) => nomina || !t.soloNomina)
                  .map((t) => (
                    <TabPane tab={t.tab} key={t.key}>
                      <Alert
                        type="info"
                        showIcon
                        message={`Guarda primero al empleado para capturar sus ${t.tab.toLowerCase()}`}
                        description="En cuanto exista el empleado, esta pestaña se habilita desde Editar Empleado o desde Capital Humano → Creditos y Movimientos."
                      />
                    </TabPane>
                  ))}
              </Tabs>
            </Form>
          </Spin>
        </div>
        <ModalPrevisualizarArchivos
          file={this.state.currentPreviewFile}
          visible={this.state.filePreviewVisible}
          onClose={this.handleCloseFilePreview}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  modulosMezcal: state.empresa.modulosMezcal,
  nomina: state.empresa.nomina,
  controlAsistencia: state.empresa.controlAsistencia,
  appMovil: state.empresa.appMovil,
  checadaRemota: state.empresa.checadaRemota,
  verificacionFacial: state.empresa.verificacionFacial,
});

export default connect(mapStateToProps)(AgregarEmpleado);